module.exports = __webpack_public_path__ + "static/media/bg_2.835f954f.jpg";